import { render, staticRenderFns } from "./entity-imports-archive.vue?vue&type=template&id=61c8b8ed&scoped=true"
import script from "./entity-imports-archive.vue?vue&type=script&lang=js"
export * from "./entity-imports-archive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8b8ed",
  null
  
)

export default component.exports